// Which contact-centre the "Call from Telnyx" button dials into, resolved
// from the browser's hostname.
//
// This started life as an inline `hostname.includes('stg-')` copied from the
// PHD, which is wrong here: the doctors dashboard is ALSO served from
// ydo-doctors-dashboard-stg.web.app, where the staging marker is a SUFFIX
// ("-stg.") rather than a prefix ("stg-"), so the button silently vanished
// on that origin (live-observed 2026-07-31). Matching a bare "stg" substring
// would be worse — it would fire on any future host that merely contains
// those letters. So: an explicit allowlist of the hosts we actually serve,
// plus a token-boundary regex that recognises "stg" as its own dot/dash
// delimited segment.
//
// Since the production contact centre shipped (2026-08), every valid
// non-staging hostname resolves to it. Null — which hides the button
// entirely — is now only the degenerate case: a missing or malformed
// hostname.

export const STAGING_CONTACT_CENTER = 'https://stg-ydo-contact-center.web.app';
export const PROD_CONTACT_CENTER = 'https://ydo-contact-center.web.app';

const KNOWN_STAGING_HOSTS = new Set([
  'stg-doctors.yourdoctors.online',
  'stg-ydo-doctor-portal.web.app',
  'stg-ydo-doctor-portal.firebaseapp.com',
  'ydo-doctors-dashboard-stg.web.app',
  'ydo-doctors-dashboard-stg.firebaseapp.com',
  'localhost',
  '127.0.0.1',
]);

// "stg" as a whole segment: leading, trailing, or delimited by . or -.
// Matches stg-doctors…, …-stg.web.app, foo.stg.bar — but NOT "hostgator".
const STAGING_TOKEN = /(^|[.-])stg([.-]|$)/;

export function isStagingHost(hostname) {
  if (typeof hostname !== 'string' || !hostname) return false;
  const host = hostname.toLowerCase();
  return KNOWN_STAGING_HOSTS.has(host) || STAGING_TOKEN.test(host);
}

export function resolveContactCenterBase(hostname) {
  if (isStagingHost(hostname)) return STAGING_CONTACT_CENTER;
  if (typeof hostname !== 'string' || !hostname) return null;
  return PROD_CONTACT_CENTER;
}
